// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-knowledge-modal-UPZeJa .semi-modal-content{max-height:calc(100vh - 100px)!important}.import-unit-type-label-D5JOqQ{margin-bottom:8px;font-size:14px;font-weight:700;line-height:20px;display:block}.create-form-L7IAAT .semi-form-field{padding-top:0;padding-bottom:24px!important}.create-form-L7IAAT .semi-form-field-label{color:var(--coz-fg-secondary);margin-bottom:0;padding:0 8px 6px;font-size:12px;font-style:normal;font-weight:500;line-height:16px}.upload-avatar-container-rMYk6a{width:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"create-knowledge-modal": `create-knowledge-modal-UPZeJa`,
	"createKnowledgeModal": `create-knowledge-modal-UPZeJa`,
	"import-unit-type-label": `import-unit-type-label-D5JOqQ`,
	"importUnitTypeLabel": `import-unit-type-label-D5JOqQ`,
	"create-form": `create-form-L7IAAT`,
	"createForm": `create-form-L7IAAT`,
	"upload-avatar-container": `upload-avatar-container-rMYk6a`,
	"uploadAvatarContainer": `upload-avatar-container-rMYk6a`
};
export default ___CSS_LOADER_EXPORT___;
